module.exports = __webpack_public_path__ + "img/error.92773218.svg";